import { Routes } from '@angular/router';
import { authGuard } from '../../guards/auth.guard';
import { profileGuard } from '../../guards/profile-guard.guard';

export const mainRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./main.component').then((m) => m.MainComponent),
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
        data: { resourceName: 'DashboardShowInMenu' },
      },
      {
        path: 'activities',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/activity/activity.routes').then((m) => m.activityRoutes),
        data: { resourceName: 'ActivityShowInMenu' },
      },
      {
        path: 'consents',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/consents/consent.routes').then((m) => m.consentRoutes),
        data: { resourceName: 'ConsentShowInMenu' },
      },
      {
        path: 'benefits',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/benefit/benefit.routes').then((m) => m.benefitRoutes),
        data: { resourceName: 'BenefitShowInMenu' },
      },
      {
        path: 'brands',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/brand/brand.routes').then((m) => m.brandRoutes),
        data: { resourceName: 'BrandShowInMenu' },
      },
      {
        path: 'carriers',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/carrier/carrier.routes').then((m) => m.carrierRoutes),
        data: { resourceName: 'CarrierShowInMenu' },
      },
      {
        path: 'customers',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/customer/customer.routes').then((m) => m.customerRoutes),
        data: { resourceName: 'CustomerShowInMenu' },
      },
      {
        path: 'customers/duplicates',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/customer-duplicate/customer-duplicate.routes').then((m) => m.customerDuplicateRoutes),
        data: { resourceName: 'CustomerDuplicateShowInMenu' },
      },
      {
        path: 'recover/customers',
        canActivate: [authGuard],
        loadComponent: () => import('./../../../components/customer/customer-recover-list/customer-recover-list.component').then((m) => m.CustomerRecoverListComponent),
        data: { resourceName: 'RecoverCustomerRead' },
      },
      {
        path: 'recover/quotes',
        canActivate: [authGuard],
        loadComponent: () => import('./../../../components/quote/quote-recover-list/quote-recover-list.component').then((m) => m.QuoteRecoverListComponent),
        data: { resourceName: 'RecoverQuoteRead' },
      },
      {
        path: 'dependents',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/dependent/dependent.routes').then((m) => m.dependentRoutes),
        data: { resourceName: 'DependentShowInMenu' },
      },
      {
        path: 'facilities',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/facility/facility.routes').then((m) => m.facilityRoutes),
        data: { resourceName: 'FacilityShowInMenu' },
      },
      {
        path: 'logs',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/log/log.routes').then((m) => m.logRoutes),
        data: { resourceName: 'LogShowInMenu' },
      },
      {
        path: 'permissions',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/permission/permission.routes').then((m) => m.permissionRoutes),
        data: { resourceName: 'PermissionShowInMenu' },
      },
      {
        path: 'permission-sets',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/permission-set/permission-set.routes').then((m) => m.permissionSetRoutes),
        data: { resourceName: 'PermissionShowInMenu' },
      },
      {
        path: 'role-permissions',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/role-permission/role-permission.routes').then((m) => m.rolePermissionRoutes),
        data: { resourceName: 'RolePermissionShowInMenu' },
      },
      {
        path: 'products',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/product/product.routes').then((m) => m.productRoutes),
        data: { resourceName: 'ProductShowInMenu' },
      },
      {
        path: 'quotes',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/quote/quote.routes').then((m) => m.quoteRoutes),
        data: { resourceName: 'QuoteShowInMenu' },
      },
      { path: 'quote-approvals', data: { resourceName: 'QuoteEdit' }, canActivate: [authGuard], loadComponent: () => import('./../../../components/quote-approval/quote-approval-list/quote-approval-list.component').then(c => c.QuoteApprovalListComponent) },
      {
        path: 'roles',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/role/role.routes').then((m) => m.roleRoutes),
        data: { resourceName: 'RoleShowInMenu' },
      },
      {
        path: 'sources',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/source/source.routes').then((m) => m.sourceRoutes),
        data: { resourceName: 'SourceShowInMenu' },
      },
      {
        path: 'subscribe-topics',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/subscribe-topic/subscribe-topic.routes').then((m) => m.subscribeTopicRoutes),
        data: { resourceName: 'SubscribeTopicShowInMenu' },
      },
      {
        path: 'topics',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/topic/topic.routes').then((m) => m.topicRoutes),
        data: { resourceName: 'TopicShowInMenu' },
      },
      {
        path: 'users',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/user/user.routes').then((m) => m.userRoutes),
        data: { resourceName: 'UserShowInMenu' },
      },
      {
        path: 'document-types',
        canActivate: [authGuard],
        loadChildren: () => import('./../../../components/document-type/document-type.routes').then((m) => m.documentTypeRoutes),
        data: { resourceName: 'DocumentTypeShowInMenu' },
      },
      {
        path: 'profile',
        canActivate: [profileGuard],
        loadComponent: () => import('./../../../components/profile/profile.component').then((m) => m.ProfileComponent),
        data: { resourceName: 'ProfileShowInMenu' },
      },
      {
        path: 'search',
        canActivate: [profileGuard],
        loadComponent: () => import('./../../../shared/components/global-search/gobal-search-list/global-search-list.component').then((m) => m.GlobalSearchListComponent),
      },  
    ],
  },
];

